import React, { Component } from "react";
import { Paper } from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

const INTID = "942B35F9-0252-432B-A753-F70050B7725B";
const ENDPOINT = "https://sdk.cchaxcess.com/api";
const ACCOUNTID = "798931";
const UID = process.env.CCH_USERNAME;
const UPW = process.env.CCH_PASSWORD;

function fetchCCH(url, options) {
  return new Promise((resolve, reject) => {
    fetch(url, options).then((response) => {
      resolve(response.json());
    });
  });
}

function authReq() {
  return new Promise(function (resolve, reject) {
    let url = `${ENDPOINT}/AuthService/v1.0/Authenticate`;
    let options = {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        IntegratorKey: INTID,
      },
      body: JSON.stringify({
        UserName: UID,
        UserSid: "Salesforce",
        Password: UPW,
        Realm: ACCOUNTID,
      }),
    };
    fetchCCH(url, options).then((json) => {
      resolve(json.Token);
    });
  });
}

function getDocsPendingApproval(token) {
  return new Promise(function (resolve, reject) {
    let url = `${ENDPOINT}/DocumentService/v1.0/Document/GetPendingApprovalDocuments`;
    let options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        IntegratorKey: INTID,
        Security: token,
      },
    };
    fetchCCH(url, options, []).then((json) => {
      resolve(json);
    });
  });
}

export default class PortalDocumentIndex extends Component {
  componentWillMount() {
    this.props.getWorkorders();
    authReq().then((token) => {
      getDocsPendingApproval(token)
        .then((json) => this.props.receiveWorkorders(json))
        .catch((err) => console.log(err));
    });
  }

  render() {
    let filter = { type: "TextFilter", delay: 500 };

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em" }}
        >
          <center>
            <h3>Portal Documents Pending Approval</h3>
          </center>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="FileGuid"
              dataSort
              filter={filter}
              isKey
              width="300"
            >
              Guid
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="FileStatus"
              dataSort
              filter={filter}
              width="75"
            >
              Status
            </TableHeaderColumn>
            <TableHeaderColumn dataField="FileName" dataSort filter={filter}>
              File Name
            </TableHeaderColumn>
            <TableHeaderColumn dataField="PortalName" dataSort filter={filter}>
              Portal Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="FileSize"
              dataSort
              filter={filter}
              width="75"
            >
              Size
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/documents/PortalDocumentIndex.js